// extracted by mini-css-extract-plugin
export default {"customButton":"style_customButton__LJI63","primary":"style_primary__s151O","secondary":"style_secondary__d8AZj","shdow":"style_shdow__OZx0J"};